import React, {Component} from 'react'

export default ({title, children}) => (
  <div>
    <h2>{title}</h2>
    <div className="semester-container">{children}</div>
  </div>
)
